<template>
    <div class="productmobile">
        <!--banner-->
        <div class="banner outer">
            <div class="inside1490">
                <div class="ban_box">
                    <div class="ban_left">
                        <h1 class="banner_title">易猎云<span style="color: #1D2754 ;">工作手机</span></h1>
                        <p class="banner_txt">专为招聘场景设计的工作手机，和易猎云招聘系统深度集成，微信好友可自动和招聘系统中的候选人进行关联和匹配，支持自动标签，精准搜索；</p>
                        <p class="banner_txt">支持系统外呼、短信，微信聊天记录系统集成等功能，支持外呼记录、录音、短信，微信沟通记录上传云端，方便和招聘系统及三方系统集成。</p>
                    </div>
                    <div class="ban_right">
                       <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/mobile/pic_01%402x.png"/>
                    </div>
                </div>
            </div>
        </div>
        <!--自动关联-->
        <div class="improve outer">
            <div class="improve_left">
                <div class="top_ridius"></div>
                <div class="pro_one">
                    <span class="pro_circle"></span>
                    <p class="pro_text">专为招聘场景设计</p>
                    <img class="pro_right_imgicon" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/mobile/icon_arrow%402x.png"/>
                </div>
                <div class="pro_two">
                    <span class="pro_circle"></span>
                    <p class="pro_text">专注招聘提效及管理提效</p>
                    <img class="pro_right_imgicon" style="width: 98px;" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/mobile/icon_arrow%402x.png"/>
                </div>
                <div class="pro_three">
                    <span class="pro_circle"></span>
                    <p class="pro_text">专业信息互通</p>
                    <img class="pro_right_imgicon" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/mobile/icon_arrow%402x.png"/>
                </div>
            </div>
            <div class="improve_right">
                <img class="improve_line_img" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/mobile/pic_connecting%20arrow%402x.png"/>
                <div class="improve_right_img">
                    <img class="improve_mobile_img" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/mobile/pic_computer.png"/>
                </div>
            </div>
            <div class="improve_title">人才库简历和微信好友自动关联</div>
            <div class="improve_img_mobile">
                <img class="improve_computer" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/mobile/pic_phone.png"/>
            </div>
        </div>
        <!--外呼能力-->
        <div class="outer capacity">
            <div class="inside1490">
                <div class="cap_title">工作手机外呼能力</div>
                <div class="cap_list">
                    <div class="cap_left">
                        <img class="cap_img" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/mobile/pic_02%402x.png"/>
                        <p class="cap_text">系统一键外呼</p>
                    </div>
                    <div class="cap_right">
                        <img class="cap_img" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/mobile/pic_0234%402x.png"/>
                        <p class="cap_text">支持外呼考核及接通率预警</p>
                    </div>
                </div>
                <div class="cap_list">
                    <div class="cap_left">
                        <img class="cap_img" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/mobile/pic_03%402x.png"/>
                        <p class="cap_text">通话录音自动上传及复盘</p>
                    </div>
                    <div class="cap_right">
                        <img class="cap_img" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/mobile/pic_04%402x.png"/>
                        <p class="cap_text">外呼AI质检</p>
                    </div>
                </div>
            </div>
        </div>
        <!--短信能力-->
        <div class="outer message">
            <div class="inside1490">
                <h3 class="msg_title">工作手机短信能力</h3>
                <div class="msg_container">
                    <div class="msg_left">
                        <div class="msg_left_title">本机短信</div>
                        <p class="msg_left_text">本机短信相比传统群发短信到达率高，效果好。<br/>本机短信显示招聘HR的真实手机号，便于相互添加微信，增加信任</p>
                    </div>
                    <div class="msg_center">
                        <img class="msg_center_img" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/mobile/pic_05%402x.png"/>
                    </div>
                    <div class="msg_right">
                        <div class="msg_circle">
                            <img class="msg_right_img" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/mobile/icon_06%402xnew.png"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--微信能力-->
        <div class="outer wechart">
            <div class="inside1490">
                <div class="wx_container">
                    <h3 class="wx_title">工作手机微信能力</h3>
                    <div class="wx_left_box">
                        <div class="wx_left_top">
                            <div class="wx_left_top_title">人才库简历和微信好友完全打通</div>
                            <p class="wx_left_top_text">支持近30个字段/标签搜索简历或微信好友</p>
                        </div>
                        <img class="wx_left_img" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/mobile/pic_07%402x.png"/>
                    </div>
                    <div class="wx_center_box">
                        <div class="wx_center_title">招聘团队加微信行为统计</div>
                        <p class="wx_center_text">支持招聘团队加好友数量考核及数据自动提取</p>
                        <img class="wx_center_img" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/mobile/pic_08%402x.png"/>
                    </div>
                    <div class="wx_right_box1">
                        <div class="wx_right_title">系统下发微信</div>
                        <div class="wx_right_text">可通过系统给候选人发微信，提升候选人触达效率。<br/>支持人才库多维度搜索条件对组织内的微信好友进行筛选及群发微信</div>
                        <img class="wx_right_img" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/mobile/pic_09%402x.png"/>
                    </div>
                    <div class="wx_right_box2">
                        <div class="wx_right_title2">微信沟通记录同步至候选人档案</div>
                        <p class="wx_right_text2">微信中和候选人的沟通记录自动同步至候选人档案，丰富候选人的求职档案</p>
                        <img class="wx_right_img2" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/mobile/pic_10%402x.png"/>
                    </div>
                </div>
            </div>
        </div>
        <!--管理抓手-->
        <div class="outer gripper">
            <div class="inside1490">
                <h3 class="gripper_title">工作手机带来更多的管理抓手</h3>
                <div class="gripper_container">
                    <div class="grimmper_icon_top">
                        人效热力图
                    </div>
                    <p class="gripper_p1">借助工作手机，招聘HR每日和候选人的沟通可以被数字化</p>
                    <p class="gripper_p2">通过人效热力图，管理者可以更多的掌控到员工的工作状态，帮助员工优化工作内容</p>
                    <img class="gripper_1_img" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/mobile/pic_11%402x.png"/>
                    <div class="gripper_box">
                        <div class="gripper_box_img">
                           外呼和加微信可以更轻松的考核
                        </div>
                        <p class="gripper_box_text">外呼数量和外呼时长可以作为团队额考核指标，系统自动提取组织下按照搜索条件运营微信群发策略</p>
                        <img class="gripper_box_img2" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/mobile/pic_12%402x.png"/>
                    </div>
                    <div class="gripeer_tips">
                        招聘特色的工作手机后台管理系统
                    </div>
                    <img class="gripeer_bottom_img" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/mobile/pic_Laptop%402x.png"/>
                </div>
            </div>
        </div>
        <div style="height: 60px;background: #F2F4FA;'"></div>
        <!--解决方案-->
        <div class="outer solution">
            <div class="inside1490">
                <h3 class="solution_title">私域流量/人才库一体化解决方案</h3>
                <div class="solution_container">
                    <div class="solution_left">
                        <h4 class="solution_left_h3">私域流量/人才库新突破</h4>
                        <p class="solution_p">在招聘平台可精准匹配出内部人才库中存在的候选人，直接工作手机外呼，节省招呼数</p>
                        <p class="solution_p">人才库的积累变得更有价值，顾问每天工作都是在做人才库的储备和激活</p>
                        <p class="solution_p">支持微信私域分享及裂变，招聘HR分享后带来的投递会自动分配给自己</p>
                    </div>
                    <div class="solution_right">
                        <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/mobile/pic_13%402x.png"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="security outer">
          <div class="inside1490 security_child">
            <div class="security_left"><img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/icon_customer_service%402x.png"/></div>
            <div class="security_right">
              <p class="p1">立即开启私域招聘提效之旅</p>
              <div class="price_box">
                <span class="pr_icon">￥</span>
                <span class="pr_text">1880/台</span>
                <span  class="pr_text2">（无后续年费）</span>
              </div>
              <div class="security_center" @click="trial()">联系客户经理</div>
            </div>
           
          </div>
      </div>
      <div class="phone_container" v-show="windowflags">
        <img class="phone_close" src="https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_Close-2@2x.png" @click="changewindows"/>
        <p class="phone_text">联系客户经理:400-0588-036</p>
      </div>
      <div class="mask" v-show="windowflags" @click="changewindows"></div>
          <!--申请试用组件-->
       <!-- <populone v-if="windowflags" :isshow="windowflags" :selectId="''" :he="true" @handleChange="changewindows" /> -->
    </div>
</template>
<script>
  import populone from "@/components/views/popul/populone";
  import { boo } from "../../../tool/apiboo.js";
  export default {
    name: "productecall",
    data() {
        return{
            windowflags: false,
        }
    },
    components: {
        populone,
    },
    methods:{
      trial(){
        this.windowflags = true;
         //跳转到视频中心
            let userinfo= localStorage.getItem('userinfo');
            console.log(userinfo);
            if(userinfo!=null){
                let newuser=JSON.parse(userinfo);
                let {name,mobile,tenantName, ...newObj} = newuser.profile;
                console.log(name,mobile);
                this.sendmessagecode(name,mobile,tenantName);
            }else{
                console.log('未登录');
            }
           
        },
        sendmessagecode(name,mobile,tenantName) {
            //标记
            const url = `https://officialsiteapi${boo()}.yilieyun.com/siteapi/Apply/SendDingDingMessage`;
            let params = new FormData();
            params.append("userName", name);
            params.append("mobile", mobile);
            params.append("tenantName", tenantName);
            let config = {
                headers: { "Content-Type": "multipart/form-data" },
            };
            var that = this;
            this.$axios
                .post(url, params, config)
                .then(function (response) {
                console.log(response.data);
                if (response.data.code == "200") {
                  
                    // that.$message.success('发送成功');
                } else {
                    
                   
                }
                })
                .catch(function (error) {
                   console.log(error);
                });
            },
        changewindows() {
         this.windowflags = false;
        },
    },
    metaInfo: {
        title: '易猎云工作手机-易猎云旗下产品',
        meta: [
          {
            name: 'keywords',
            content: '易猎云，招聘管理系统，RPO，HRO，ATS，批量招聘，数字化'
          },
          {
            name: 'description',
            content: '专为招聘场景设计的工作手机，和易猎云招聘系统深度集成，微信好友可自动和招聘系统中的候选人进行关联和匹配，支持自动标签，精准搜索，支持系统外呼，系统短信，微信聊天记录系统集成，支持私域流量运营'
          }
        ]
    },
}
</script>
<style lang="less" scoped>
@import "~@/assets/css/style/index.less";
.productmobile{
    margin-top: 85px;
    .banner {
        width: 100%;
        height: 470px;
        background: #ffffff;
        .ban_box{
            display: flex;
            .ban_left{
                flex: 1;
            }
            .ban_right{
                width: 347px;
                height: 347px;
                margin-top: 38px;
                margin-right: 235px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .banner_title{
            color: #1D2754;
            line-height: 112px;
            color: #0B6AFB;
            line-height: 112px;
            font-size: 60px;
            margin-top: 92px;
        }
        .banner_txt{
            font-size: 24px;
            color: #3A4D70;
            line-height: 40px;
        }
  }
  .improve{
    position: relative;
    width: 100%;
    height: 769px;
    display: flex;
    background: linear-gradient( 151deg, #F6F7FD 0%, #F6F7FD 100%);
    .improve_left{
        flex: 1;
        height: 769px;
        background: linear-gradient( 325deg, #DDEEFF 0%, #DFEFFF 37%, #EFF1FF 100%);
        border: 1px solid;
        border-image: linear-gradient(156deg, rgba(220, 234, 249, 1), rgba(201, 223, 243, 1)) 1 1;
        position: relative;
        .top_ridius{
            position: absolute;
            width: 70%;
            height: 769px;
            background: linear-gradient( 151deg, #F6F7FD 0%, #F6F7FD 100%);
            right: -1px;
            top: -1px;
            border-bottom-left-radius: 100%;
        }
        .pro_one{
            display: flex;
            position: absolute;
            width: 360px;
            height: 105px;
            background: linear-gradient( 90deg, #F6F7FD 0%, #DFF0FF 100%);
            border-radius: 53px;
            right: 190px;
            top: 150px;
        }
        .pro_two{
            display: flex;
            position: absolute;
            width: 360px;
            height: 105px;
            background: linear-gradient( 90deg, #F6F7FD 0%, #DFF0FF 100%);
            border-radius: 53px;
            right: 120px;
            top: 327px;
        }
        .pro_three{
            display: flex;
            position: absolute;
            width: 360px;
            height: 105px;
            background: linear-gradient( 90deg, #F6F7FD 0%, #DFF0FF 100%);
            border-radius: 53px;
            right: 20px;
            top: 481px;
        }
        .pro_right_imgicon{
            width: 98px;
            height: 14px;
            margin-right: 20px;
            z-index: 9;
            margin-top: 42px;
        }
        .pro_circle{
            display: inline-block;
            width: 12px;
            height: 12px;
            background: linear-gradient( 90deg, #69B0FF 0%, #5669F1 100%);
            border-radius: 50%;
            margin-top: 46px;
            vertical-align: middle;
        }
        .pro_text{
            flex: 1;
            line-height: 130px;
            font-size: 19px;
            color: #24262B; 
            margin-left: 20px;
            margin-top: -15px;
        }
    }
    .improve_right{
        position: relative;
        flex: 1.2;
        height: 769px;
        .improve_line_img{
            position: absolute;
            width: 219px;
            top: 370px;
            z-index: 9;
            left: 150px;
        }
        .improve_right_img{
            position: absolute;
            width: 727px;
            height: 426px;
            background: #ffffff;
            left: 190px;
            bottom: 154px;
            .improve_mobile_img{
                width: 100%;
                height: 100%;
            }
        }
       
    }
    .improve_title{
        position: absolute;
        font-size: 36px;
        color: #1561F1;
        left: 50%;
        transform: translateX(-50%);
        top: 77px;
    }
    .improve_img_mobile{
        position: absolute;
        width: 200px;
        height: 410px;
        left: 50%;
        transform: translateX(-50%);
        bottom: 72px;
        .improve_computer{
            width: 100%;
            height: 100%;
        }
    }
  }
  .capacity{
    .cap_title{
        text-align: center;
        color: #1D2754;
        font-size: 36px;
        margin-top: 38px;
    }
    .cap_list{
        display: flex;
        margin-top: 70px;
        justify-content: space-between;
        .cap_left{
            width: 672px;
            height: 637px;
            background-image: url('https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/mobile/pic_bg%402x.png');
            background-repeat: no-repeat;
            background-size: 100%;
            border-radius: 14px;
        }
        .cap_right{
            width: 672px;
            height: 637px;
            background-image: url('https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/mobile/pic_bg%402x.png');
            background-repeat: no-repeat;
            background-size: 100%;
            border-radius: 14px;

        }
        .cap_img{
            width:560px;
            height: 358px;
            margin-top: 63px;
            margin-left: 50px;
        }
        .cap_text{
            font-size: 32px;
            color: #505DEA;
            line-height: 45px;
            margin-top: 103px;
            margin-left: 50px;
        }
    }
  }
  .message{
    .msg_title{
        text-align: center;
        font-size: 36px;
        color: #1D2754;
        margin-top: 103px;
    }
    .msg_container{
        display: flex;
        width: 100%;
        height: 400px;
        background: #F8F9FF;
        border-radius: 21px;
        border: 1px solid #E5E9F4;
        margin-top: 70px;
        .msg_left{
            width: 445px;
            .msg_left_title{
                display: inline-block;
                font-size: 32px;
                color: #1D2754;
                margin-left: 60px;
                margin-top: 50px;
            }
            .msg_left_text{
                width: 337px;
                display: inline-block;
                font-size: 14px;
                color: #7D82A2;
                line-height: 31px;
                margin-top: 66px;
                margin-left: 60px;
            }
        }
        .msg_center{
            width: 360px;
            margin-left: 48px;
            margin-top: 85px;
            .msg_center_img{
                width: 361px;
                height: 232px;
            }
        }
        .msg_right{
            flex: 1;
            position: relative;
            .msg_right_img{
                position: absolute;
                width: 311px;
                height: 401px;
                margin-left: 153px;
                left: 22%;
                top: 50%;
                transform: translate(-50%,-50%);
            }
            .msg_circle{
                position: absolute;
                display: inline-block;
                width: 533px;
                height: 533px;
                border-radius: 50%;
                background: linear-gradient( 180deg, #BED4FF 0%, #F0F5FF 100%);
                right: 37px;
                top: -69px;
            }
        }
    }
  }
  .wechart{
    width: 100%;
    height: 1432px;
    margin-top: 109px;
    .wx_container{
        position: relative;
        width: 100%;
        height: 1432px;
        background: url('https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/mobile/pics_03%402x.png');
        background-size: 100%;
        background-repeat: no-repeat;
        background-position: 50%;
        .wx_title{
            font-size: 36px;
            color: #1D2754;
            text-align: center;
            margin-top: 64px;
        }
        .wx_left_box{
            position: absolute;
            width: 340px;
            height: 790px;
            bottom: 86px;
            .wx_left_top{
                width: 100%;
                .wx_left_top_title{
                    font-size: 24px;
                    color: #1D2754;
                }
                .wx_left_top_text{
                    font-size: 18px;
                    color: #7D82A2;
                    margin-top: 20px;
                }
            }
            .wx_left_img{
                width: 284px;
                height: 685px;
                margin-left: 29px;
                margin-top: 27px;
            }
        }
        .wx_center_box{
            position: absolute;
            width: 505px;
            height: 290px;
            left: 50%;
            top: 280px;
            transform: translateX(-50%);
            background: #ffffff;
            .wx_center_title{
                font-size: 24px;
                color: #1D2754;
                text-align: center;
            }
            .wx_center_text{
                font-size: 18px;
                color: #7D82A2;
                margin-top: 20px;
                text-align: center;
            }
            .wx_center_img{
                width: 505px;
                height: 171px;
                margin-top: 30px;
            }
        }
        .wx_right_box1{
            position: absolute;
            width: 357px;
            height: 290px;
            right: 0px;
            top: 200px;
            .wx_right_title{
                font-size: 24px;
                color: #1D2754;
                text-align: center;
            }
            .wx_right_text{
                font-size: 18px;
                color: #7D82A2;
                line-height: 32px;
                margin-top: 20px;
            }
            .wx_right_img{
                width: 357px;
                height: 188px;
                margin-top: 26px;
            }
        }
        .wx_right_box2{
            position: absolute;
            width: 437px;
            height: 530px;
            right: 0px;
            bottom: 140px;
            background: #ffffff;
            .wx_right_title2{
                font-size: 24px;
                color: #1D2754;
                text-align: center;
            }
            .wx_right_text2{
                width: 414px;
                font-size: 18px;
                color: #7D82A2;
                line-height: 30px;
                margin-left: 28px;
                margin-top: 20px;
            }
            .wx_right_img2{
                width: 437px;
                height: 395px;
            }
        }
    }
  }
  .gripper{
    width: 100%;
    background: #F2F4FA;
    .gripper_title{
        font-size: 36px;
        color: #1D2754;
        text-align: center;
        line-height: 112px;
        margin-top: 34px;
    }
    .gripper_container{
        position: relative;
        width: 100%;
        height: 1956px;
        background: #FFFFFF;
        box-shadow: 0px 2px 4px 0px #E2E8F4;
        border: 1px solid #83A4CC;
        margin-top: 11px;
        .grimmper_icon_top{
            position: absolute;
            width: 285px;
            height: 62px;
            top: -31px;
            left: 30px;
            background-image: url('https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/mobile/icon_01%402x.png');
            background-size: 100%;
            background-repeat: no-repeat;
            font-size: 26px;
            color: #FFFFFF;
            text-align: center;
            line-height: 62px;
        }
        .gripper_p1{
            font-size: 22px;
            color: #7D82A2;
            margin-left: 69px;
            margin-top: 94px;
            line-height: 30px;
        }
        .gripper_p2{
            font-size: 22px;
            color: #7D82A2;
            margin-left: 69px;
            line-height: 30px;
        }
        .gripper_1_img{
            width: 1017px;
            height: 514px;
            margin-left: 50px;
            margin-top: 40px;
        }
        .gripper_box{
            position: relative;
            width: 100%;
            height: 382px;
            .gripper_box_img{
                width: 538px;
                height: 62px;
                margin-top: 91px;
                margin-left: 50px;
                background-image: url('https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/mobile/icon_02%402x.png');
                background-size: 100%;
                background-repeat: no-repeat;
                font-size: 26px;
                color: #FFFFFF;
                text-align: center;
                line-height: 62px;
            }
            .gripper_box_text{
                width: 556px;
                font-size: 22px;
                color: #7D82A2;
                line-height: 30px;
                margin-left: 79px;
                margin-top: 30px;
            }
            .gripper_box_img2{
                width: 766px;
                height: 457px;
                position: absolute;
                top: -157px;
                right: 70px;
            }
        }
        .gripeer_tips{
            width: 538px;
            height: 62px;
            background-image: url('https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/mobile/icon_02%402x.png');
            background-size: 100%;
            background-repeat: no-repeat;
            margin: 0 auto;
            text-align: center;
            font-size: 26px;
            color: #FFFFFF;
            line-height: 62px;
        }
        .gripeer_bottom_img{
            width: 1258px;
            height: 1150px;
            margin: 0 auto;
            margin-top: 20px;
        }
    }
  }
  .solution{
    width: 100%;
    height: 850px;
    background-image: url('https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/mobile/bg_blue%402x.png');
    background-repeat: no-repeat;
    background-size: 105%;
    background-position-y: 100%;
    padding-top: 80px;
    box-sizing: border-box;
    .solution_title{
        font-size: 36px;
        color: #FFFFFF;
        text-align: center;
    }
    .solution_container{
        display: flex;
        .solution_left{
            flex: 1;
            .solution_left_h3{
                font-size: 32px;
                color: #FFFFFF;
                margin-left: 68px;
                margin-top: 116px;
            }
            .solution_p{
                width: 460px;
                font-size: 20px;
                color: #FFFFFF;
                line-height: 39px;
                margin-left: 68px;
                margin-top: 67px;
            }
        }
        .solution_right{
            width: 910px;
            height: 494px;
            img{
                width: 100%;
                height: 100%;
                margin-top: 90px;
            }
        }
    }
  }
  .security{
      width: 100%;
      height: 354px;
      background-image: url('https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/bg_01%402x.png');
      background-repeat: no-repeat;
      background-size: 100% 102%;
      padding-top: 53px;
      box-sizing: border-box;
      .security_child{
        display: flex;
        .security_left{
            margin-left: 346px;
              img{
                width: 145px;
                height: 128px;
              }
        }
        .security_right{
             margin-left: 37px;
              .p1{
              display: inline-block;
              font-size: 48px;
              font-weight: 500;
              color: #ffffff;
              text-align: left;
              margin-top: 47px;
          }
          .price_box{
            margin-left: 23px;
            margin-top: 38px;
            .pr_icon{
                font-size: 34px;
                color: #FFFFFF;
            }
            .pr_text{
                font-size: 44px;
                color: #FFFFFF;
            }

            .pr_text2{
                font-size: 24px;
                color: #FFFFFF;
            }
            
          }
        }
        .security_center{
          width: 158px;
          height: 66px;
          background: #FFFFFF;
          border-radius: 7px;
          line-height: 66px;
          text-align: center;
          font-size: 24px;
          color: #215FFF;
          cursor: pointer;
          margin: 0 auto;
          margin-top: 40px;
        }
      }
    }
    .phone_container{
        position: fixed;
        width: 500px;
        height: 180px;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        background: #ffffff;
        border-radius: 12px;
        z-index: 21;
        .phone_close{
            position: absolute;
            width: 32px;
            height: 32px;
            right: 15px;
            top: 10px;
            cursor: pointer;
        }
        .phone_text{
            text-align: center;
            line-height: 180px;
            font-size: 24px;
            color: #215FFF;
        }
    }
    .mask{
        position: fixed;
        background: #000000;
        width: 100%;
        height: 2000px;
        top: 0px;
        left: 0px;
        opacity: 0.39;
        z-index: 20;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/pages/product/Productmobile.vue